// "Falar com o suporte" (PO1-3509): na Central e no painel "Como usar esta tela".
//   - embarcador e admin: abre o ChatModal do Autopilot já no assunto de suporte,
//     com a tela atual no contextoInicial; o chamado só sai depois da
//     confirmação (gate da PO1-3508);
//   - transportadora (MeuFrete) e quem não tem Autopilot: só o e-mail e o portal,
//     em texto selecionável (decisão 9 do kickoff).
// Sem `?.`/`??`: o build roda em CRA 3.4 / Node 12.
import React, { useState } from "react";
import { Button } from "reactstrap";

import ChatModal from "../../components/autopilot/ChatModal";
import { AUTOPILOT_COLORS } from "../../components/autopilot/styles";
import { SUPORTE_EMAIL, SUPORTE_PORTAL, SUPORTE_PORTAL_ROTULO } from "../../constants/suporte";
import { useAuth } from "../../hooks/auth";

export function contextoSuporte(tela) {
  return `O usuário quer falar com o suporte. Tela: ${tela || "(não informada)"}. Ajude a descrever o problema e proponha abrir o chamado.`;
}

export function temAutopilot(user) {
  return !!user && user.setor !== "transportadora";
}

export function ContatoSuporte({ compacto }) {
  return (
    <div
      className="suporte-contato"
      style={{ color: AUTOPILOT_COLORS.text, fontSize: compacto ? "0.8rem" : "0.86rem", lineHeight: 1.6, userSelect: "text" }}
    >
      <span style={{ color: AUTOPILOT_COLORS.muted }}>Suporte Everlog: </span>
      <a href={`mailto:${SUPORTE_EMAIL}`} style={{ color: AUTOPILOT_COLORS.accent, fontWeight: 600 }}>
        {SUPORTE_EMAIL}
      </a>
      <span style={{ color: AUTOPILOT_COLORS.muted }}> · </span>
      <a href={SUPORTE_PORTAL} target="_blank" rel="noopener noreferrer" style={{ color: AUTOPILOT_COLORS.accent, fontWeight: 600 }}>
        {SUPORTE_PORTAL_ROTULO}
      </a>
    </div>
  );
}

// `tela`: caminho da tela de onde o pedido saiu (pathname + search).
// `onAbrir`: opcional, chamado ao abrir o chat (ex.: fechar o painel por trás).
// `onSolicitar(contextoInicial)`: opcional; quando vem, quem chama abre o chat
// (o PainelAjuda fecha e desmontaria um ChatModal que morasse aqui dentro).
export default function FalarComSuporte({ tela, onAbrir, onSolicitar, size = "sm", style, block, compacto }) {
  const { user } = useAuth();
  const [aberto, setAberto] = useState(false);

  if (!temAutopilot(user)) return <ContatoSuporte compacto={compacto} />;

  const telaAtual = tela || (typeof window !== "undefined" ? window.location.pathname + window.location.search : "");

  return (
    <>
      <Button
        type="button"
        size={size}
        color="default"
        outline
        block={block}
        style={style}
        onClick={() => {
          if (onSolicitar) {
            onSolicitar(contextoSuporte(telaAtual));
            return;
          }
          if (onAbrir) onAbrir();
          setAberto(true);
        }}
        data-testid="falar-com-suporte"
      >
        <i className="tim-icons icon-support-17" style={{ marginRight: 6 }} />
        Falar com o suporte
      </Button>
      {onSolicitar ? null : (
        <ChatModal
          isOpen={aberto}
          onClose={() => setAberto(false)}
          title="Suporte Everlog"
          contextoInicial={contextoSuporte(telaAtual)}
        />
      )}
    </>
  );
}
